// Mirror of backend WatcherGUI/ErrorCodes.py values used by frontend UI formatting.
export const ErrorCodes = {
  // Authentication/Authorization errors (1000-1999)
  AUTH_SESSION_EXPIRED: 1001,
  AUTH_INSUFFICIENT_PERMISSIONS: 1002,
  AUTH_INVALID_CREDENTIALS: 1003,

  // Database errors (2000-2999)
  DB_CONNECTION_FAILED: 2001,
  DB_QUERY_FAILED: 2002,
  DB_TRANSACTION_FAILED: 2003,

  // API errors (3000-3999)
  API_MISSING_PARAMETER: 3001,
  API_INVALID_PARAMETER: 3002,
  API_INTERNAL_ERROR: 3003,

  // File/Upload errors (4000-4999)
  FILE_TOO_LARGE: 4001,
  FILE_INVALID_TYPE: 4002,
  FILE_PROCESSING_FAILED: 4003,

  // Business Logic errors (5000-5999)
  RESOURCE_NOT_FOUND: 5001,
  RESOURCE_ALREADY_EXISTS: 5002,
};

